import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'

export interface PartyPermissions {
    canUpdate: boolean
    canCreateRelationship: boolean
    canEndRelationship: boolean
}

/**
 * Per-control permission gate for the PartyDetail page.
 *
 * One field per distinct boundary — never aggregate. Mirrors the per-control
 * shape used by {@code useIdentityPermissions} (607.01) and
 * {@code useInboundConnectorPermissions} (603.03) so callers can extend the
 * record with new boundaries without re-shaping the consumer code.
 *
 * - {@code canUpdate} — gates the edit affordances on the SourcesCard and the
 *                       InlineAttributeEditor on the PartyDetail page.
 * - {@code canCreateRelationship} — gates the inline Add affordance on every
 *                       relationship section (issue 686).
 * - {@code canEndRelationship} — gates the inline Remove affordance on every
 *                       active relationship row (issue 686).
 */
export function usePartyPermissions(): PartyPermissions {
    const {hasPermission} = useAuth()
    return {
        canUpdate: hasPermission(permissions.parties.update),
        canCreateRelationship: hasPermission(permissions.partyRelationships.create),
        canEndRelationship: hasPermission(permissions.partyRelationships.update),
    }
}
